import { Dispatch, SetStateAction } from 'react';

export enum CarriageWayEnum {
  SINGLE = 'SingleCarriageway',
  DOUBLE = 'DualCarriageway',
  FOOTPATH = 'FootPath',
}

export type Footer = 'signify' | 'trilux' | 'white';

export interface IRoadLayoutConfig {
  carriageWay: CarriageWayEnum;
  borderAreaLeft: boolean;
  borderAreaRight: boolean;
}

export interface IFamilyConfig {
  familyIds: string[];
}

export interface IRoadwayConfig {
  roadWidth: number;
  widthOfCentralReservation?: number;
  numberOfLanes: number;
  covering: RoadCoveringEnum;
  q0: q0Enum;
  borderAreaRightWidth?: number;
  borderAreaRightKerbDistance?: number;
  borderAreaRightCovering?: BorderAreaCoveringEnum;
  borderAreaLeftWidth?: number;
  borderAreaLeftKerbDistance?: number;
  borderAreaLeftCovering?: BorderAreaCoveringEnum;
  roadLength: number;
}

export interface IProjectConfig {
  project_name: string;
  location: string;
  comment: string;
  project_id: string;
  name_of_road: string;
}

/* M Classes */
export type MClassesValue =
  | MClassEnum
  | MClassLavTargetValuesEnum
  | MClassUoTargetValuesEnum
  | MClassUlTargetValuesEnum
  | MClassFTiTargetValuesEnum
  | MClassReiTargetValuesEnum;

export type MClassesKey =
  | keyof typeof MClassEnum
  | keyof typeof MClassLavTargetValuesEnum
  | keyof typeof MClassUoTargetValuesEnum
  | keyof typeof MClassUlTargetValuesEnum
  | keyof typeof MClassFTiTargetValuesEnum
  | keyof typeof MClassReiTargetValuesEnum;

export enum MClassEnum {
  M1 = 'M1',
  M2 = 'M2',
  M3 = 'M3',
  M4 = 'M4',
  M5 = 'M5',
  M6 = 'M6',
}

export enum MClassLavTargetValuesEnum {
  M1 = '2.00',
  M2 = '1.50',
  M3 = '1.00',
  M4 = '0.75',
  M5 = '0.50',
  M6 = '0.30',
}

export enum MClassUoTargetValuesEnum {
  M1 = '0.40',
  M2 = '0.40',
  M3 = '0.40',
  M4 = '0.40',
  M5 = '0.35',
  M6 = '0.35',
}

export enum MClassUlTargetValuesEnum {
  M1 = '0.70',
  M2 = '0.70',
  M3 = '0.60',
  M4 = '0.60',
  M5 = '0.40',
  M6 = '0.40',
}

export enum MClassFTiTargetValuesEnum {
  M1 = '10%',
  M2 = '10%',
  M3 = '15%',
  M4 = '15%',
  M5 = '15%',
  M6 = '20%',
}

export enum MClassReiTargetValuesEnum {
  M1 = '0.35',
  M2 = '0.35',
  M3 = '0.30',
  M4 = '0.30',
  M5 = '0.30',
  M6 = '0.30',
}

/* C Classes */
export type CClassesValue =
  | CClassEnum
  | CClassEavTargetValuesEnum
  | CClassUoTargetValuesEnum
  | CClassFTiTargetValuesEnum;

export type CClassesKey =
  | keyof typeof CClassEnum
  | keyof typeof CClassEavTargetValuesEnum
  | keyof typeof CClassUoTargetValuesEnum
  | keyof typeof CClassFTiTargetValuesEnum;

export enum CClassEnum {
  C0 = 'C0',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  C5 = 'C5',
}

export enum CClassEavTargetValuesEnum {
  C0 = '50.00',
  C1 = '30.00',
  C2 = '20.00',
  C3 = '15.00',
  C4 = '10.00',
  C5 = '7.50',
}

export enum CClassUoTargetValuesEnum {
  C0 = '0.40',
  C1 = '0.40',
  C2 = '0.40',
  C3 = '0.40',
  C4 = '0.40',
  C5 = '0.40',
}

export enum CClassFTiTargetValuesEnum {
  C0 = '15%',
  C1 = '15%',
  C2 = '15%',
  C3 = '20%',
  C4 = '20%',
  C5 = '20%',
}

/* P Classes */
export type PClassesValue =
  | PClassEnum
  | PClassEavTargetValuesEnum
  | PClassEminTargetValuesEnum
  | PClassEvminTargetValuesEnum
  | PClassEscminTargetValuesEnum
  | PClassFTiTargetValuesEnum;

export type PClassesKey =
  | keyof typeof PClassEnum
  | keyof typeof PClassEavTargetValuesEnum
  | keyof typeof PClassEminTargetValuesEnum
  | keyof typeof PClassEvminTargetValuesEnum
  | keyof typeof PClassEscminTargetValuesEnum
  | keyof typeof PClassFTiTargetValuesEnum;

export enum PClassEnum {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4',
  P5 = 'P5',
  P6 = 'P6',
}

export enum PClassEavTargetValuesEnum {
  P1 = '15.00',
  P2 = '10.00',
  P3 = '7.50',
  P4 = '5.00',
  P5 = '3.00',
  P6 = '2.00',
}

export enum PClassEminTargetValuesEnum {
  P1 = '3.00',
  P2 = '2.00',
  P3 = '1.50',
  P4 = '1.00',
  P5 = '0.60',
  P6 = '0.40',
}

export enum PClassEvminTargetValuesEnum {
  P1 = '5.00',
  P2 = '3.00',
  P3 = '2.50',
  P4 = '1.50',
  P5 = '1.00',
  P6 = '0.60',
}

export enum PClassEscminTargetValuesEnum {
  P1 = '3.00',
  P2 = '2.00',
  P3 = '1.50',
  P4 = '1.00',
  P5 = '0.60',
  P6 = '0.40',
}

export enum PClassFTiTargetValuesEnum {
  P1 = '20%',
  P2 = '25%',
  P3 = '25%',
  P4 = '30%',
  P5 = '30%',
  P6 = '35%',
}

/* ------ */

export enum RoadCoveringEnum {
  R1 = 'R1',
  R2 = 'R2',
  R3 = 'R3',
  R4 = 'R4',
  R5 = 'R5',
  C1 = 'C1',
  C2 = 'C2',
}

export enum BorderAreaCoveringEnum {
  DARK = 'dark',
  MEDIUM = 'medium',
  LIGHT = 'light',
}

export enum q0Enum {
  q0005 = 0.05,
  q0007 = 0.07,
  q0008 = 0.08,
  q0009 = 0.09,
  q0010 = 0.1,
}

export enum LuminaireLayoutEnum {
  LEFT = 'Left',
  RIGHT = 'Right',
  BOTH = 'Both',
  STAGGERED = 'Staggered',
  CENTERED = 'Centered',
  CENTERED_SINGLE = 'Centered_Single',
  ROPE = 'Rope',
}

export interface ILightingClassConfig {
  roadClasses: MClassEnum | CClassEnum | PClassEnum;
  borderAreaRightClasses?: CClassEnum | PClassEnum | undefined;
  borderAreaLeftClasses?: CClassEnum | PClassEnum | undefined;
  customClasses:
    | {
        mainCustomClass?: CustomClassData | undefined;
        rightBorderCustomClass?: CustomClassData | undefined;
        leftBorderCustomClass?: CustomClassData | undefined;
      }
    | undefined;
}

export interface ILuminaireLayoutConfig {
  luminaireConfig: LuminaireLayoutEnum;
}

export enum OptimizationTypeEnum {
  MAXIMUM_DISTANCE = 'maximum_distance',
  LOWEST_CONSUMPTION = 'lowest_consumption',
}

export type RangeWithStep = {
  min: number;
  max: number;
  step: number;
}

export type RangeWithStepOrNumber = {
  value: number;
  rangeValue: RangeWithStep;
}

export interface IOptimizationConfig {
  optimizationType: OptimizationTypeEnum;
  ignoreTi: boolean;
  ignoreRei: boolean;
  shouldOptimizeDistanceBetweenPoles: boolean;
  distanceBetweenPoles: RangeWithStepOrNumber;
  shouldOptimizeHeightOfTheLightPoint: boolean;
  heightOfTheLightPoint: RangeWithStepOrNumber;
  shouldOptimizeOverhang: boolean;
  overhang: RangeWithStepOrNumber;
  shouldOptimizeTiltOfTheLuminaire: boolean;
  tiltOfTheLuminaire: RangeWithStepOrNumber;
  maintenanceFactor: number;
}

export interface ISdFpath {
  name: string;
  e_avg: number;
  e_min: number;
  u_oe: number;
}

export type IRoadConfigLayoutConfigCallBack = Dispatch<
  SetStateAction<IRoadLayoutConfig>
>;

export type IRoadwayConfigCallback = Dispatch<SetStateAction<IRoadwayConfig>>;

export type ILightingClassConfigCallBack = Dispatch<
  SetStateAction<ILightingClassConfig>
>;

export type ILuminaireLayoutConfigCallBack = Dispatch<
  SetStateAction<ILuminaireLayoutConfig>
>;

export type IFamilyConfigCallBack = Dispatch<SetStateAction<IFamilyConfig>>;

export type IOptimizationConfigCallBack = Dispatch<
  SetStateAction<IOptimizationConfig>
>;

export interface ProjectData {
  portfolio_id: string | null;
  currentStep: number;
  familyConfig: IFamilyConfig;
  roadLayoutConfig: IRoadLayoutConfig;
  roadwayConfig: IRoadwayConfig;
  lightingClassConfig: ILightingClassConfig;
  luminaireLayoutConfig: ILuminaireLayoutConfig;
  optimizationConfig: IOptimizationConfig;
  projectConfig: IProjectConfig;
  selectedResult: string;
}

export interface PortfolioData {
  portfolio: Portfolio;
  families: Family[];
}

export interface Portfolio {
  id: string;
  name: string;
  user: string;
  zip_file: string;
}

export interface Family {
  id: string;
  name: string;
  image: string;
  description: string;
  short_description: string;
}

export interface TooltipData {
  roadway_cover: string;
  roadway_qzero: string;
  roadway_wocr: string;
  road_classes_rei: string;
  road_classes_fti: string;
  road_classes_evmin: string;
  road_classes_escmin: string;
  optimization_type: string;
  optimization_dbp: string;
  optimization_holp: string;
  optimization_overhang: string;
  optimization_totl: string;
  optimization_mf: string;
  optimization_ignore: string;
}

export interface MCustomClassData {
  [key: string]: string | number;
  class_type: 'M';
  Lm_av: number;
  L_uo: number;
  L_ul: number;
  fTI: number;
  Rei: number;
}

export interface CCustomClassData {
  [key: string]: string | number;
  class_type: 'C';
  Em_av: number;
  E_uo: number;
  fTI: number;
}

export interface PCustomClassData {
  [key: string]: string | number;
  class_type: 'P';
  Em_av: number;
  Em_min: number;
  fTI: number;
  Evm_min: number;
  Escm_min: number;
}

export type CustomClassData =
  | MCustomClassData
  | CCustomClassData
  | PCustomClassData;

export type CustomClassModalData = {
  mainCustomClass: CustomClassData | undefined;
  rightBorderCustomClass: CustomClassData | undefined;
  leftBorderCustomClass: CustomClassData | undefined;
};

export type PreSelectedClass =
  | `M${1 | 2 | 3 | 4 | 5 | 6}`
  | `C${0 | 1 | 2 | 3 | 4 | 5}`
  | `P${1 | 2 | 3 | 4 | 5 | 6}`
  | undefined;
